const LayoutPublic = () => import('@/prerender-pages/layout/LayoutPublic');
const Home = () => import('@/prerender-pages/pages/Home');
const Contacts = () => import('@/prerender-pages/pages/Contacts');
const StubRedirect = () => import('@/prerender-pages/pages/StubRedirect');

const createLinkToLanding = (path) => `https://newcrom.com/${path}`;

const routesForRedirecting = [
  {
    path: '/hardware',
    meta: {
      redirect: createLinkToLanding(''),
    },
    component: StubRedirect,
  },
  {
    path: '/try',
    meta: {
      redirect: createLinkToLanding(''),
    },
    component: StubRedirect,
  },
  {
    path: '/newcrom',
    meta: {
      redirect: createLinkToLanding(''),
    },
    component: StubRedirect,
  },
  {
    path: '/autosampler',
    meta: {
      redirect: createLinkToLanding('autosampler/'),
    },
    component: StubRedirect,
  },
  {
    path: '/pump',
    meta: {
      redirect: createLinkToLanding('pump/'),
    },
    component: StubRedirect,
  },
  {
    path: '/detector',
    meta: {
      redirect: createLinkToLanding('detector/'),
    },
    component: StubRedirect,
  },
  {
    path: '/valve',
    meta: {
      redirect: 'https://sielc.com/product/alltesta-high-pressure-switching-valve',
    },
    component: StubRedirect,
  },
  {
    path: '/cromite',
    meta: {
      redirect: createLinkToLanding('cromite/'),
    },
    component: StubRedirect,
  },
  {
    path: '/alltesta-gradient',
    meta: {
      redirect: createLinkToLanding('alltesta-gradient/'),
    },
    component: StubRedirect,
  },
  {
    path: '/alltesta-isocratic',
    meta: {
      redirect: createLinkToLanding('alltesta-isocratic/'),
    },
    component: StubRedirect,
  },
  {
    path: '/samplify',
    meta: {
      redirect: createLinkToLanding('samplify/'),
    },
    component: StubRedirect,
  },
  {
    path: '/streamlc',
    meta: {
      redirect: createLinkToLanding('/'),
    },
    component: StubRedirect,
  },
];

const routesForPrerendering = [
  {
    path: '/',
    component: Home,
    name: 'home',
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: Contacts,
  },
  ...routesForRedirecting,
];

const routes = [
  {
    path: '',
    component: LayoutPublic,
    children: routesForPrerendering,
  },
  // Not found
  {
    path: '*',
    name: 'NotFound',
  },
];

module.exports = routes;
module.exports.routesForPrerendering = routesForPrerendering;
